import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import React from 'react';
import { calculatePercentage } from '../../../lib/utils.js';
import AuthorizedAction from '../../AuthorizedAction.js';
import SubHeader from '../../SubHeader.jsx';
import styles from './InitiativeParticipationsHeader.module.css';

const InitiativeParticipationsHeader = ({
  initiative,
  initiativeParticipation,
  resultsCount,
}) => {
  let count;
  let completedCount;
  if (initiativeParticipation) {
    count = initiativeParticipation.leavesCount;
    completedCount = initiativeParticipation.leavesCompletedCount;
  } else {
    count = initiative.groupParticipationCount;
    completedCount = initiative.groupParticipationCompletedCount;
  }

  return (
    <SubHeader flexJustify small>
      <div className="flex flex-1">
        <h2>Participating Groups</h2>
        <strong className="header-item bordered text-muted">
          Current Level&nbsp;:&nbsp;
          <span className="text-primary">
            {resultsCount} {pluralize('Result', resultsCount)}
          </span>
        </strong>

        {initiative.completionTracked &&
          initiative.project.manageProjectEntities && (
            <AuthorizedAction action="update" subject="changeImpact">
              <strong
                className={`header-item ${styles.completion} bordered text-muted`}
              >
                Completed:&nbsp;
                <span className="text-primary">
                  {calculatePercentage(completedCount, count)}%
                </span>
                <span className="text-primary">
                  {completedCount}/{count}
                </span>
              </strong>
            </AuthorizedAction>
          )}
      </div>
    </SubHeader>
  );
};

InitiativeParticipationsHeader.propTypes = {
  initiative: PropTypes.shape({
    completionTracked: PropTypes.bool,
    participationCount: PropTypes.number.isRequired,
    participationCompletedCount: PropTypes.number.isRequired,
  }).isRequired,
  initiativeParticipation: PropTypes.shape({
    leavesCount: PropTypes.number.isRequired,
    leavesCompletedCount: PropTypes.number.isRequired,
  }),
  resultsCount: PropTypes.number.isRequired,
};

export default InitiativeParticipationsHeader;
